// Keys — loaded from Vite env vars (set in Vercel dashboard, never hardcoded here).
// Supabase anon key: safe to be public by design (RLS enforces access).
// Razorpay key: must NEVER be hardcoded — set VITE_RZP_KEY in Vercel env vars.
// Dev/Pro status is server-authoritative (profiles.is_developer / is_pro,
// protected by the profiles_update_safe RLS policy) — no client-side email
// check or env var needed for it anymore.
var _env = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {}
export var SUPA_URL  = _env.VITE_SUPA_URL  || ''
export var SUPA_KEY  = _env.VITE_SUPA_KEY  || ''
export var RZP_KEY   = _env.VITE_RZP_KEY   || ''
export var WA_COMMUNITY = 'https://chat.whatsapp.com/GCEONvdK5Vx1luFVcVD8QH'
export var WA_SUPPORT   = '918089558314'
export var FREE_SCANS = 5
// Models — Groq deprecated Llama 4 Scout/Maverick (vision) and the old
// llama-3.2-90b-vision-preview fallback; as of July 2026 qwen/qwen3.6-27b is
// the ONLY vision-capable model Groq offers, so there's no real second model
// to fall back to anymore — VISION_FALLBACK just retries the same model,
// which still helps for transient errors/rate limits.
// llama-3.1-8b-instant and llama-3.3-70b-versatile are both scheduled for
// shutdown 08/16/26 — swapped proactively to Groq's recommended replacements.
export var HAIKU_MODEL  = 'openai/gpt-oss-20b'
export var CODEX_MODEL  = 'openai/gpt-oss-120b'
export var VISION_MODEL = 'qwen/qwen3.6-27b'
export var VISION_FALLBACK = 'qwen/qwen3.6-27b'

export var HUNT_DATA = {
  mainline:[
    {name:"Dodge Charger Daytona",rarity:"Common",india:"150-200",priority:"Low"},
    {name:"Honda Civic Type R",rarity:"Uncommon",india:"200-350",priority:"Medium"},
    {name:"Porsche 911 GT3 RS",rarity:"Rare",india:"400-800",priority:"High"},
    {name:"Ferrari 488 GT3",rarity:"Rare",india:"500-900",priority:"High"},
    {name:"Toyota Supra MK4",rarity:"Uncommon",india:"250-450",priority:"Medium"},
    {name:"Nissan Skyline GT-R R34",rarity:"Rare",india:"500-1000",priority:"High"},
    {name:"'69 Chevrolet Camaro",rarity:"Common",india:"150-200",priority:"Low"},
    {name:"Lamborghini Huracán",rarity:"Uncommon",india:"250-400",priority:"Medium"},
    {name:"Ford Mustang Shelby GT500",rarity:"Uncommon",india:"200-350",priority:"Medium"},
    {name:"Dodge Viper GTS-R",rarity:"Rare",india:"400-800",priority:"High"},
  ],
  th:[
    {name:"Bone Shaker (TH)",rarity:"Treasure Hunt",india:"1200-2500",priority:"HIGH"},
    {name:"Twin Mill (TH)",rarity:"Treasure Hunt",india:"1000-2000",priority:"HIGH"},
    {name:"Deora III (STH)",rarity:"Super Treasure Hunt",india:"4000-10000",priority:"MUST GRAB"},
    {name:"'69 Camaro Z28 (STH)",rarity:"Super Treasure Hunt",india:"5000-12000",priority:"MUST GRAB"},
    {name:"Porsche 934.5 (STH)",rarity:"Super Treasure Hunt",india:"6000-15000",priority:"MUST GRAB"},
    {name:"Dodge Charger (TH)",rarity:"Treasure Hunt",india:"1500-3000",priority:"HIGH"},
    {name:"'67 Camaro (STH)",rarity:"Super Treasure Hunt",india:"5000-11000",priority:"MUST GRAB"},
  ],
  premium:[
    {name:"Car Culture — Real Riders",rarity:"Premium",india:"600-1200",priority:"High"},
    {name:"Boulevard Series",rarity:"Premium",india:"500-1000",priority:"High"},
    {name:"Fast & Furious Series",rarity:"Premium",india:"500-1000",priority:"High"},
    {name:"Retro Entertainment",rarity:"Premium",india:"600-1200",priority:"High"},
    {name:"Racing Circuit",rarity:"Premium",india:"400-800",priority:"Medium"},
  ],
  vintage:[
    {name:"Redline Era Cars (pre-1977)",rarity:"Vintage",india:"3000-20000",priority:"BIG VALUE"},
    {name:"Blackwall Era (1977-1983)",rarity:"Vintage",india:"1000-5000",priority:"HIGH"},
    {name:"Error Cars (any year)",rarity:"Error Car",india:"5000-50000",priority:"BIG VALUE"},
    {name:"Malaysia base variants",rarity:"Rare",india:"800-3000",priority:"High"},
    {name:"Convention Exclusives",rarity:"Rare",india:"2000-8000",priority:"HIGH"},
  ]
}
